import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

/**
 * ContentBlock:
 *  - Display the contents of all Sections Except for DesignSection
 *    in Web View
 */
export function ContentBlock(props) {
  const className = `${style.content} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

ContentBlock.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * child components to render on ContentBlock
   */
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
    PropTypes.string,
  ]),
};

ContentBlock.defaultProps = {
  className: "",
};
